// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/projection-sky.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projection-idle {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #add3ef url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
  color: #203d52;
  text-align: center;
  padding: 24px;
}
.projection-idle h1 {
  font:
    400 44px / 1.25 Georgia,
    serif;
  margin: 0;
}
.projection-idle p {
  margin-top: 16px;
  font-size: 16px;
}
@media (max-width: 600px) {
  .projection-idle h1 {
    font-size: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ProjectionPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oFAAwF;EACxF,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;AACA;EACE;;SAEO;EACP,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".projection-idle {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #add3ef url('../public/assets/projection-sky.webp') center / cover no-repeat;\n  color: #203d52;\n  text-align: center;\n  padding: 24px;\n}\n.projection-idle h1 {\n  font:\n    400 44px / 1.25 Georgia,\n    serif;\n  margin: 0;\n}\n.projection-idle p {\n  margin-top: 16px;\n  font-size: 16px;\n}\n@media (max-width: 600px) {\n  .projection-idle h1 {\n    font-size: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
